// extracted by mini-css-extract-plugin
export var warningWrapper = "t_s6 d_w d_bF d_bP d_bJ d_n d_0 d_bS";
export var btn = "t_mY d_cD d_b1 d_dB d_dr";